// stub file for offshore reports state
// the entity state provided by withEntities in the store is currently sufficient for our needs
// may be expanded in the future as needed

// export interface OffshoreReportsState {
// }

// export const INITIAL_OFFSHORE_REPORTS_STATE: OffshoreReportsState = {};
export const INITIAL_OFFSHORE_REPORTS_STATE: object = {};
